<template>

<div class="title">

    <div class="title-text">{{ text }}</div>
    <div class="title-subtext" v-if="subtext">{{ subtext }}</div>

</div>

</template>

<script>

export default {

    props: ['text', 'subtext']

}

</script>

<style scoped>

.title {
    padding: 10px 20px;
    margin-top: 10px;
}

.title:first-child {
    margin-top: 0px;
}

.title-text {
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    font-weight: 300;
    letter-spacing: 2px;
}

.title-subtext {
    font-size: 12px;
    margin-top: 2px;
    opacity: 0.4;
    color: #fff;
    font-weight: 400;
    letter-spacing: 2px;
}

</style>
